import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, columns }) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
        flexDirection: `${columns === 2 ? 'row' : 'column'}`,
        alignItems: `${columns === 2 ? 'flex-end' : 'flex-start'}`
    },
    '&:hover': {
        '& .staffItem-imageImage': {
            transform: 'scale(1.05)',
            [theme.breakpoints.down('520')]: {
                transform: 'scale(1.03)'
            }
        }
    },
    '& .staffItem': {
        '&-image': {
            position: 'relative',
            width: '100%',
            overflow: 'hidden',
            borderRadius: toRem(4),

            '& > div': {
                height: 'auto !important' // SimpleImg fix
            },

            [theme.breakpoints.up('lg')]: {
                ...(columns === 2 && {
                    width: `calc(54.83% - ${toRem(36)})`,
                    margin: `0 ${toRem(36)} 0 0`
                })
            },
            [theme.breakpoints.down('520')]: {
                // height: toRem(240)
            },
            '&Image': {
                display: 'block',
                minWidth: '100%',
                transition: 'transform 400ms ease-in-out 0ms'
            }
        },
        '&-content': {
            width: '100%',
            padding: toRems([20, 20, 0, 20]),
            fontSize: toRem(14),
            lineHeight: '170%',
            color: theme.colors.text.default,
            [theme.breakpoints.up('520')]: {
                padding: toRems([20, 0, 0, 0])
            },
            [theme.breakpoints.up('lg')]: {
                ...(columns === 2 && {
                    padding: 0,
                    width: '45.16%'
                })
            },
            '&Name': {
                fontSize: toRem(14),
                lineHeight: '130%',
                fontWeight: theme.typography.fontWeight.medium,
                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(16),
                    lineHeight: '125%'
                }
            },
            '&Position': {
                ...(columns === 2 && {
                    margin: toRems([3, 0, 0, 0])
                })
            },
            '&Speaking': {
                color: theme.colors.text.goldDark,
                margin: toRems([5, 0, 0, 0])
            },
            '&Description': {
                margin: toRems([20, 0, 0, 0]),
                [theme.breakpoints.up('lg')]: {
                    ...(columns === 2 && {
                        margin: toRems([40, 0, 0, 0])
                    })
                }
            },
            '& p': {
                margin: 0,
                fontSize: 'inherit',
                lineHeight: 'inherit'
            }
        }
    }
})

export default style
